import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export const PopularSearches = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/seo/collections").then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <div data-testid="footer-popular-searches" className="mx-auto max-w-7xl px-6 pb-10">
      <div className="text-xs uppercase tracking-widest text-white/50 mb-3">Popular searches</div>
      <ul className="flex flex-wrap gap-x-5 gap-y-2 text-sm text-white/70">
        {items.map((c) => (
          <li key={c.slug}><Link to={`/shop/${c.slug}`} data-testid={`footer-collection-${c.slug}`} className="hover:text-[#F59E0B]">{c.title}</Link></li>
        ))}
      </ul>
    </div>
  );
};
